import * as React from 'react';

export interface SidebarHeaderNextProps {
  /** A custom node to render from the bottom */
  children?: React.ReactNode;
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook?: string;
  /** A text to show as the header title */
  title?: React.ReactNode;
  /** A text to show as the header subtitle */
  subtitle?: React.ReactNode;
  /**
   * Specifies a CSS class name to be appended to the component's root element.
   * @internal
   */
  className?: string;
}

export default class SidebarHeaderNext extends React.PureComponent<SidebarHeaderNextProps> {}
